import AxiosConfig from '../../../config/AxiosConfig';

const useDeleteSavDraft = () => {
  const deleteDraft = async (id) => {
    try {
      const response = await AxiosConfig.create(
        'delete',
        `/savdraft/${id}/delete/`
      )
        .call()
        .getResponseData();

      return response;
    } catch (err) {
      console.error('Failed to delete SAV draft:', err);
      throw new Error(`SAV draft delete failed: ${err?.message}`);
    }
  };

  return {
    deleteDraft,
  };
};

export default useDeleteSavDraft;
